var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[_c('div',{staticClass:"flex items-center h-10"},[_c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.chipColor(_vm.value)}},[_c('span',[_vm._v(_vm._s(_vm.text(_vm.value)))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }